import { Box, Chip } from '@mui/joy';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';
import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';

export function RankBadge({ rank }) {
    if (!rank) return <Box component="span">-</Box>;
    const palette = { 1: ['#ffe59b', '#d89a22', '#49320b'], 2: ['#edf4fc', '#99afc5', '#253e56'], 3: ['#e6a582', '#a34f32', '#422219'] }[rank];
    return <Box component="span" aria-label={`${rank} место`} sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 32, flexShrink: 0, fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}>
        {palette ? <Box component="svg" viewBox="0 0 40 48" aria-hidden="true" focusable="false" data-medal-rank={rank} sx={{ width: 32, height: 38, display: 'block' }}>
            <path d="M9 26 5 46l10-4 6 4 2-20z" fill={palette[1]} />
            <path d="m19 26 1 20 7-5 9 3-7-19z" fill={palette[2]} />
            <circle cx="20" cy="19" r="17" fill={palette[1]} stroke={palette[0]} strokeWidth="1.4" />
            <circle cx="20" cy="19" r="13.6" fill={palette[0]} />
            <circle cx="20" cy="19" r="11.2" fill="none" stroke={palette[1]} strokeWidth=".8" />
            <text x="20" y="25.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="21" fill={palette[2]}>{rank}</text>
        </Box> : rank}
    </Box>;
}

export function RaceBadge({ period = 'week', lane = 'photographer', children, sx }) {
    const month = period === 'month';
    const admin = lane === 'administrator';
    const colors = admin ? {
        color: month ? '#c5faf1' : '#aaf3e7',
        background: month ? '#174e57' : '#163d40',
        borderColor: month ? '#398b8b' : '#347878',
    } : {
        color: month ? '#f1e3ff' : '#dbb2ff',
        background: month ? '#54218b' : '#352044',
        borderColor: month ? '#9152c8' : '#6b4886',
    };
    const Icon = admin ? DesktopWindowsRoundedIcon : CameraAltRoundedIcon;
    return <Chip size="sm" variant="soft" data-award-lane={lane} data-award-period={period}
        startDecorator={<Icon sx={{ fontSize: 14, color: 'inherit' }} />} sx={{ '&&&': {
        ...colors, borderWidth: 1, borderStyle: 'solid', fontWeight: 800,
        '& .MuiChip-label, & .MuiChip-startDecorator': { color: 'inherit' }, ...sx,
    } }}>{children || ({ week: 'Гонка недели', month: 'Гонка месяца', all: 'Общий рейтинг' }[period])}</Chip>;
}

export function visibleLanes(data, role) {
    const primary = (role || data?.role) === 'admin' ? ['administrator']
        : (role || data?.role) === 'admin_photographer' ? ['photographer', 'administrator'] : ['photographer'];
    return ['photographer', 'administrator'].filter(lane => primary.includes(lane)
        || data?.visible_lanes?.includes(lane) || Number(data?.wins?.[lane]) > 0
        || Number(data?.earned?.[lane]) > 0 || Object.values(data?.positions?.[lane] || {}).some(Boolean));
}
